<template>
  <div class="main">
    <c-panel title="Marcas de veículo" titleIcon="fas fa-trademark">
      <!-- Item 10 do edital: "registrar as marcas e tipos dos veículos utilizados no município". -->
      <crud-simples endpoint="api/transporte-escolar/marca" :perfis-escrita="[0, 1, 4, 5, 6, 12]" rotuloNovo="NOVA MARCA"
                    nomeSingular="marca" placeholderBusca="Pesquisar por nome"
                    :campos="campos" :colunas="colunas" dialogLargura="460px"></crud-simples>
    </c-panel>
  </div>
</template>

<script>
import CrudSimples from '@/shared/crud-simples/crud-simples.vue'

export default {
  components: { CrudSimples, cPanel: () => import('@/shared/c-panel/c-panel.vue') },
  data: () => ({
    campos: [{ chave: 'nome', label: 'Nome', obrigatorio: true, span: 24, max: 80 }],
    colunas: [{ chave: 'nome', label: 'Nome' }]
  })
}
</script>
